import { RuleTargetType } from "@/api/rulesLibrary";

export type RuleAction = "block" | "allow";

export interface Rule {
	id: string;
	/** The resource the rule targets, e.g. a domain or signature id. */
	target: string;
	/** The action applied to the target. */
	action: RuleAction;
	type: RuleTargetType;
	/** Applied-rule state returned only in a live classroom context. */
	enabled?: boolean;
	effective?: boolean;
	conflictedBy?: string;
	overriddenBy?: string;
}

export interface List {
	id: string;
	title: string;
	rules: Rule[];
}

/** A library list currently applied to this class. */
export interface AppliedList extends List {
	teacherId: string;
	teacherName: string;
	teacherEmail: string;
	teacherUsername: string;
}

export function isAppliedList(list: List): list is AppliedList {
	return "teacherName" in list;
}
